import React from "react";
import {
  DatePicker,
  FieldDropSide,
  ManageCensusLayout,
  MultiSelectDropdown,
  CsplTable as Table,
  Link,
  AddToolTip,
} from "../../../../components";

const columns = [
  {
    label: "Investment name",
    className: "column-name",
    columnName: "investmentName",
  },
  {
    label: "Percentage",
    className: "column-percentage",
    columnName: "percentage",
  },
];
const data = [
  {
    sourceMapping: "Pre Tax",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
  {
    sourceMapping: "After Tax",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
  {
    sourceMapping: "Roth",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
];

export const InvestmentMapping = (props) => {
  return (
    <div className="source-allocation-mapping">
      <div className="source-allocation-header">Investment mapping</div>
      <div
        className="distribution-transaction-table"
        style={{ marginTop: "1rem" }}
      >
        <Table className="investment-mapping-table">
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data.map((e, i) => {
              return (
                <Table.Tr key={i}>
                  <Table.Td className="w-50">{e.sourceMapping}</Table.Td>
                  <Table.Td className="w-50">{e.contributions}</Table.Td>
                </Table.Tr>
              );
            })}
            <Table.Tr>
              <Table.Td className="w-50">Total Percentage</Table.Td>
              <Table.Td className="w-50">90%</Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </div>
    </div>
  );
};
